import { useEffect } from "react";
import { useSelector } from "react-redux";

export function useError(cb) {
  const errors = useSelector((state) => state.goals.errors);
  const status = useSelector((state) => state.goals.status);

  useEffect(() => {
    if (status === "success") {
      cb();
    }
  }, [status]);

  return { errors, status };
}
